export default {
    isRatebookEnabledGrade: function (driverGradeName) {
        return driverGradeName.toLowerCase().includes('bch+');
    },
    netCost: function(ratebook, term) {
        const cost = ratebook?.employeeCostCompanyCar?.totals_NetPresentValueNPV;
        return cost ? (Number(cost)/Number(term)).toFixed(2) : null;
    },
    netCostPounds(ratebook, term) {
        if (!this.netCost(ratebook, term)) {
            return null;
        }

        const parts = this.netCost(ratebook, term).split('.');
        return parts[0];
    },
    netCostPence(ratebook, term) {
        if (!this.netCost(ratebook, term)) {
            return null;
        }
        const parts = this.netCost(ratebook, term).split('.');
        return parts[1];
    },
    oneOffContribution: function(ratebook, term) {
        const cost = ratebook?.employeeCostCompanyCar?.motoringAndFinance_CapitalContributions;
        return cost ? Number(cost).toFixed(2) : null;
    },
    vehicleRental: function(ratebook, term) {
        return ratebook?.companyCostCompanyCar?.motoringAndFinance_RentalsPayments ? Number(ratebook?.companyCostCompanyCar?.motoringAndFinance_RentalsPayments/Number(term)).toFixed(2) : null; // Replace to come from jaama
    },
    tradeUpDownRawValue: function(ratebook) {
        return ratebook?.employeeCostCompanyCar?.motoringAndFinance_PrivateUseContributions;
    },
    tradeUpDown: function(ratebook, term) {
        return this.tradeUpDownRawValue(ratebook) ? `${(Number(this.tradeUpDownRawValue(ratebook))/Number(term)).toFixed(2)}` : null;
    },
    wholeLifeCost: function(ratebook, term) {
        return ratebook?.companyCostCompanyCar?.totals_Total ? Number(ratebook?.companyCostCompanyCar?.totals_Total/Number(term)).toFixed(2) : null;
    },
    averageMonthlyBik: function(ratebook, term) {
        const cost = ratebook?.employeeCostCompanyCar?.carBenefit_IncomeTaxOnCarBenefit;
        return cost ? (Number(cost)/Number(term)).toFixed(2) : null;
    },
    bikAmounts: function(ratebook) {
        return ratebook?.bikMonthlyAmounts ? ratebook?.bikMonthlyAmounts.map((amount) => {
            return {
                year: amount.taxYearEnd,
                amount: Number(amount.amount).toFixed(2)
            }
        }) : [];
    },
    oneOffContributionRemaining: function(ratebook, maxMonthlyContribution, term) {
        const totalContribution = this.oneOffContribution(ratebook, term);
        return totalContribution && maxMonthlyContribution ? (Number(maxMonthlyContribution) * term) - Number(totalContribution) : null
    },
    wholeLifeCostRemaining: function(ratebook, maxWholeLifeCost, term) {
        const selectedWholeLifeCost = this.wholeLifeCost(ratebook, term);
        return maxWholeLifeCost && selectedWholeLifeCost ? Number(maxWholeLifeCost) - Number(selectedWholeLifeCost) : null
    },

    // Check config for what we should/shouldnt show
    showWholeLifeCosts: function(adminPortalProduct) {
        return adminPortalProduct?.your_shortlist_display_estimated_whole_life_cost;
    },
    showVehicleRental: function(adminPortalProduct) {
        return adminPortalProduct?.your_shortlist_display_vehicle_rental_cost;
    },
}
